import { useTheme } from "@emotion/react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Typography,
  Paper,
} from "@mui/material";
import React from "react";
import ContactForm from "../component/contact/ContactForm";

const ContactUs = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* HEADER */}
      <Box textAlign="center" mb={10}>
        <Typography
          variant="h2"
          fontWeight={800}
          gutterBottom
          color="primary"
          sx={{
            lineHeight: 1.2,
            letterSpacing: "-0.5px",
          }}
        >
          Get in Touch
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ maxWidth: 700, mx: "auto", lineHeight: 1.7 }}
        >
          We’re here to help. Whether you're a school or a parent,
          reach out to us and our team will respond promptly.
        </Typography>
      </Box>

      <Grid container spacing={8} alignItems="stretch">
        {/* CONTACT FORM */}
        <Grid item xs={12} md={7}>
          <Paper
            elevation={0}
            sx={{
              p: 6,
              borderRadius: 4,
              border: "1px solid rgba(0,0,0,0.06)",
              boxShadow: "0 10px 40px rgba(0,0,0,0.04)",
              height: "100%",

              transition: "all 0.35s ease",
              cursor: "pointer",

              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.08)",
              },
            }}
          >
            <ContactForm />
          </Paper>
        </Grid>

        {/* CONTACT INFO */}
        <Grid item xs={12} md={5}>
          <Paper
            elevation={0}
            sx={{
              p: 6,
              borderRadius: 4,
              border: "1px solid rgba(0,0,0,0.06)",
              boxShadow: "0 10px 40px rgba(0,0,0,0.04)",
              height: "100%",

              transition: "all 0.35s ease",
              cursor: "pointer",

              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.08)",
              },
            }}
          >
            <Typography variant="h5" fontWeight={600} mb={5}>
              Contact Information
            </Typography>

            {/* PHONE */}
            <Box
              display="flex"
              gap={3}
              mb={4}
              alignItems="center"
              sx={{
                p: 2,
                borderRadius: 3,
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.02)",
                  transform: "translateX(4px)",
                },
              }}
            >
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: theme.palette.primary.main + "15",
                  color: theme.palette.primary.main,

                  transition: "all 0.3s ease",

                  ".MuiBox-root:hover &": {
                    transform: "scale(1.1)",
                    bgcolor: theme.palette.primary.main,
                    color: "#fff",
                  },
                }}
              >
                <PhoneIcon />
              </Avatar>

              <Box>
                <Typography variant="body1" fontWeight={600}>
                  +91 9458693639
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  +91 8700007517
                </Typography>
              </Box>
            </Box>

            {/* EMAIL */}
            <Box
              display="flex"
              gap={3}
              mb={4}
              alignItems="center"
              sx={{
                p: 2,
                borderRadius: 3,
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.02)",
                  transform: "translateX(4px)",
                },
              }}
            >
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: theme.palette.primary.main + "15",
                  color: theme.palette.primary.main,

                  transition: "all 0.3s ease",

                  ".MuiBox-root:hover &": {
                    transform: "scale(1.1)",
                    bgcolor: theme.palette.primary.main,
                    color: "#fff",
                  },
                }}
              >
                <EmailIcon />
              </Avatar>

              <Box>
                <Typography
                  variant="body1"
                  fontWeight={600}
                  component="a"
                  href="mailto:info@myschoolling.com"
                  sx={{
                    textDecoration: "none",
                    color: "inherit",
                    "&:hover": {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  info@myschoolling.com
                </Typography>
              </Box>
            </Box>

            {/* ADDRESS */}
            <Box
              display="flex"
              gap={3}
              mb={4}
              alignItems="center"
              sx={{
                p: 2,
                borderRadius: 3,
                transition: "all 0.3s ease",

                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.02)",
                  transform: "translateX(4px)",
                },
              }}
            >
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: theme.palette.primary.main + "15",
                  color: theme.palette.primary.main,

                  transition: "all 0.3s ease",

                  ".MuiBox-root:hover &": {
                    transform: "scale(1.1)",
                    bgcolor: theme.palette.primary.main,
                    color: "#fff",
                  },
                }}
              >
                <LocationOnIcon />
              </Avatar>

              <Box>
                <Typography variant="body1" fontWeight={600}>
                  Versynix Global Pvt. Ltd.
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  93/295/21,<br />
                  RDA Colony, Indira Nagar,<br />
                  Raebareli, Uttar Pradesh – 229001, India
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactUs;